/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Invite_OnlyInputs */

const en_us2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only people with the code can join.`)
};

const pt_br2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só entra quem tem o código.`)
};

const es_419_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo quien tenga el código puede unirse.`)
};

const pt_pt2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só entra quem tem o código.`)
};

const fr_fr2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seules les personnes qui ont le code peuvent rejoindre.`)
};

const de_de2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur wer den Code hat, kann beitreten.`)
};

const it_it2_clubs_invite_only = /** @type {(inputs: Clubs_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Può entrare solo chi ha il codice.`)
};

/**
* | output |
* | --- |
* | "Only people with the code can join." |
*
* @param {Clubs_Invite_OnlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_invite_only = /** @type {((inputs?: Clubs_Invite_OnlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Invite_OnlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_invite_only(inputs)
	if (locale === "es-419") return es_419_clubs_invite_only(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_invite_only(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_invite_only(inputs)
	if (locale === "de-DE") return de_de2_clubs_invite_only(inputs)
	if (locale === "it-IT") return it_it2_clubs_invite_only(inputs)
	return en_us2_clubs_invite_only(inputs)
});
export { clubs_invite_only as "clubs.invite_only" }